// Starlink Admin SL
export const STARLINK_ADMIN_SL_CHNAGE_SUB_ORG = 'Change Sub Organization';
export const STARLINK_ADMIN_SL_MOBILE_PRIORITY = 'Mobile Priority';
export const STARLINK_ADMIN_SL_PAUSE_SERVICE_LINE = 'Pause Service Line';
export const STARLINK_ADMIN_SL_RESUME_SERVICE_LINE = 'Resume Service Line';
export const SERVICE_PLAN = 'SERVICE PLAN';
export const STARLINK_ADMIN_SL_DETAILS = 'Service Line Details';
export const STARLINK_ADMIN_SL_TOP_UP = 'Top Up';
export const STARLINK_ADMIN_DEVICES = 'Terminals';
export const STARLINK_ADMIN_PUBLIC_IP = 'Public IP';
// export const STARLINK_ADMIN_ROUTERS = 'Routers';
export const STARLINK_ADMIN_BETA_DEVICES = 'Devices (Beta)';